import { forwardRef } from 'react';

import cn from 'classnames/bind';
import PropTypes, { elementType } from 'prop-types';
import { DynamicComponent } from 'ui';
import { getColorType } from 'utils/types';

import s from './BorderedItem.module.scss';

const cx = cn.bind(s);

const BorderedItem = forwardRef(
  (
    {
      children,
      as = 'div',
      active,
      hasHoverEffect = true,
      color,
      height = '',
      className,
      ...attrs
    },
    ref,
  ) => (
    <DynamicComponent
      ref={ref}
      tag={as}
      className={cx(className, 'item', color, height, { active, hasHoverEffect })}
      {...attrs}
    >
      {children}
    </DynamicComponent>
  ),
);

BorderedItem.displayName = 'BorderedItem';
BorderedItem.propTypes = {
  color: getColorType(['grey']),
  as: PropTypes.oneOfType([PropTypes.string, elementType]),
  height: PropTypes.oneOf(['small', '']),
  hasHoverEffect: PropTypes.bool,
};
export default BorderedItem;
